<script lang="ts">
  /**
   * The proto's `.seg` control: equal columns, accent fill on the active one,
   * optional small caption under each label ("oletus" / "vaihtoehto").
   */
  export interface SegmentOption {
    id: string;
    label: string;
    sub?: string;
  }

  let {
    options,
    value,
    disabled = false,
    onchange,
    label,
  }: {
    options: SegmentOption[];
    value: string | null;
    disabled?: boolean;
    onchange: (id: string) => void;
    label?: string;
  } = $props();
</script>

<div class="seg" role="radiogroup" aria-label={label} style="grid-template-columns: repeat({options.length}, 1fr)">
  {#each options as o (o.id)}
    <button
      type="button"
      role="radio"
      aria-checked={o.id === value}
      class:on={o.id === value}
      disabled={disabled}
      onclick={() => { if (o.id !== value) onchange(o.id); }}
    >
      {o.label}
      {#if o.sub}<small>{o.sub}</small>{/if}
    </button>
  {/each}
</div>

<style>
  .seg {
    display: grid;
    background: var(--viisi-surface-2);
    border-radius: 12px;
    padding: 3px;
    gap: 3px;
  }
  .seg button {
    padding: 9px 8px;
    border-radius: 9px;
    font-weight: 700;
    font-size: 13px;
    color: var(--viisi-ink-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.1;
  }
  .seg button:disabled { cursor: default; opacity: 0.7; }
  .seg button small {
    font-size: 10.5px;
    font-weight: 600;
    color: var(--viisi-ink-3);
    margin-top: 2px;
  }
  .seg button.on { background: var(--viisi-accent); color: var(--viisi-accent-ink); }
  .seg button.on small { color: var(--viisi-accent-ink); opacity: 0.75; }
</style>
